import { useScroll } from '@/features/shared/Hooks/scroll/useScroll';
import useIsMobile from '@/features/shared/Hooks/useIsMobile';
import Hammer from 'hammerjs';
import { useCallback, useMemo, useRef, useState } from 'react';
import TagManager from 'react-gtm-module';

export const useTabbedCardLogic = (tabs: TabContentType[] = []) => {
  const isMobile = useIsMobile();
  const tabsCount = useMemo(() => tabs?.length || 0, [tabs]);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const { scrollTo } = useScroll(window);
  const contentViewRef = useRef<HTMLDivElement>(null);

  // TODO: move to witGTM using custom event
  const pushDataLayer = useCallback(
    (index: number) => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'trackEvent-tabsNavSlide',
          event_name: 'tabs_nav_slide',
          title: tabs[index].tabTitle?.text,
          index_num: index,
        },
      });
    },
    [tabs],
  );

  const getToTab = useCallback(
    (direction: 'next' | 'prev') => {
      setCurrentTabIndex((prev) => {
        const newTabPosition = direction === 'next' ? prev + 1 : prev - 1;
        const newIndex =
          newTabPosition > tabsCount - 1 || newTabPosition < 0 ? prev : newTabPosition;
        pushDataLayer(newIndex);
        return newIndex;
      });
    },
    [setCurrentTabIndex, tabsCount, pushDataLayer],
  );

  const onTabChangeClicking = useCallback(
    (selectedIndex: number) => {
      setCurrentTabIndex(selectedIndex);
      if (isMobile) {
        if (contentViewRef.current) {
          scrollTo(contentViewRef.current, { offset: 100 });
        }
      }
    },
    [isMobile, scrollTo],
  );

  const onSwipe = useCallback(
    (event) => {
      if (event.direction === Hammer.DIRECTION_LEFT) {
        getToTab('next');
      }
      if (event.direction === Hammer.DIRECTION_RIGHT) {
        getToTab('prev');
      }

      if (contentViewRef.current) {
        scrollTo(contentViewRef.current, { offset: 100 });
      }
    },
    [getToTab, scrollTo],
  );

  return { onSwipe, currentTabIndex, onTabChangeClicking, contentViewRef };
};
